<button id="caja" (click)="showDescription()">
    <p id="txt">
        {{text}}
    </p>
</button>
